import type { CourseResponse } from '@lms/api-client/backend';
import { Button } from '@lms/ui/button';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@lms/ui/card';
import { Link } from 'react-router-dom';
import { useLocale, useTranslations } from 'use-intl';

// Ports app/[brand]/admin/courses/_components/course-card.tsx. The manage
// button is gated to super-admins by the caller (`isSuperAdmin`).
export function CourseCard({
  slug,
  course,
  isSuperAdmin,
}: {
  slug: string;
  course: CourseResponse;
  isSuperAdmin: boolean;
}) {
  const t = useTranslations('addcourse');
  const locale = useLocale();

  const title =
    course.data[locale]?.name ||
    course.data.en?.name ||
    Object.values(course.data)[0]?.name ||
    '-';

  return (
    <Card className="card bg-background w-96 shadow-xl">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex h-60 items-center justify-center overflow-clip rounded">
          <img
            src={course.image || '/placeholder.png'}
            alt={t('course_image')}
            className="object-cover"
          />
        </div>
      </CardContent>
      <CardFooter className="grid grid-cols-1 gap-4">
        <Button className="w-full" asChild>
          <Link to={`/${slug}/course-preview/${course.id}`} target="_blank">
            {t('preview_course')}
          </Link>
        </Button>
        {isSuperAdmin && (
          <Button className="w-full" asChild variant="outline">
            <Link to={`/${slug}/admin/courses/${course.id}`}>
              {t('manage_course')}
            </Link>
          </Button>
        )}
      </CardFooter>
    </Card>
  );
}
